// @ts-nocheck
export default {
  getNotifications: state => state.notifications.items,
  getPendingNotifications: state => state.notifications.items.filter(item => !item.read)
}
